import styled from "styled-components";
import { CSSProperties } from "react";

export const formStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "left",
  marginTop: "20px",
  borderLeft: "3px solid black",
  borderTop: "3px solid black",
  borderRight: "3px solid black",
  background: "#f0f4f7",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  // Ajuste apenas para mobile
  ...(window.innerWidth <= 768 && {
    justifyContent: "center",
    alignItems: "center",
  }),
};
export const formStyleRepresentante: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "left",
  borderLeft: "3px solid black",
  borderBottom: "3px solid black",
  borderRight: "3px solid black",
  background: "#f0f4f7",
  borderBottomLeftRadius: "10px",
  borderBottomRightRadius: "10px",
  ...(window.innerWidth <= 768 && {
    justifyContent: "center",
    alignItems: "center",
  }),
};
export const buttonOk: CSSProperties = {
  backgroundColor: "#003644",
  borderColor: "#003644",
  color: "white",
};
export const buttonCancel: CSSProperties = {
  backgroundColor: "#f44336",
  borderColor: "#f44336",
  color: "white",
};

export const layout = {
  //Layout que altera o tamanho e a posição dos nomes e labels dos formulários de : Empreendimentos,Especificações de Apto,Cadastrar Apartamento,AtualizarCadastro,CadastroProprietario
  labelCol: { span: 7 },
  wrapperCol: { span: 16 },
};
export const layoutAp = {
  //Layout que altera o tamanho e a posição dos nomes e labels do formulário: Mais Info do Apartamento
  labelCol: { span: 16 },
  wrapperCol: { span: 8 },
};

export const btnStyle: CSSProperties = {
  marginTop: 20,
  borderWidth: "3px",
  borderRadius: "12px",
  backgroundColor: "rgb(0, 54, 68)",
  color: "#FFFFFF",
};

export const Container = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 10% 90% / 100%;
`;

export const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

export const Title = styled.h1`
  font-size: 25px;
  font-weight: bold;
  color: #003644;
  margin-top: 15px;
  margin-left: 15px;
  @media (max-width: 768px) {
    font-size: 20px; /* Reduz o tamanho da fonte */
    margin-top: 10px; /* Ajusta o espaçamento */
    margin-left: 10px;
  }

  @media (max-width: 480px) {
    font-size: 18px; /* Ainda menor para telas muito pequenas */
    margin-top: 8px;
    margin-left: 8px;
  }
`;
export const SubTitleUsuario = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #003644;
  margin-top: 15px;
  margin-left: 15px;
`;
export const TextUsuario = styled.p`
  font-size: 16px;
  color: #20231c;
  margin-left: 15px;
`;
export const ContainerModalBtn = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
`;
